import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatTableDataSource } from '@angular/material/table';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { IconModule, LinkModule, LoaderModule, ScrollbarModule, TableConfig, TableModule } from '@michelin/theme';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ImportFileXlsxStatus } from 'src/app/interfaces/importFileXlsxStatus';
import { UtilService } from 'src/app/util/util.service';
import { URL } from '../../../../environments/environment';
import { ImportFileService } from '../../import-file/import-file.service';

@Component({
  selector: 'mic-app-historic-xlsx-modal',
  templateUrl: './historic-xlsx-modal.component.html',
  styleUrls: ['./historic-xlsx-modal.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    ScrollbarModule,
    LoaderModule,
    TableModule,
    LinkModule,
    IconModule,
    MatTabGroup,
    MatTab,
    MatTabLabel
  ]
})
export class HistoricXlsxModalComponent implements OnInit {
  readonly dialogRef = inject<MatDialogRef<HistoricXlsxModalComponent>>(MatDialogRef);
  readonly data = inject(MAT_DIALOG_DATA);
  private readonly fileService = inject(ImportFileService);
  readonly utilService = inject(UtilService);
  private readonly cdr = inject(ChangeDetectorRef);

  private readonly DEBOUNCE_TIME = 200;

  search = new FormControl();
  dataSource = new MatTableDataSource();

  ngOnInit(): void {
    this.fileService.getXlsxStatusesByImportFileId(this.data).subscribe((result) => {
      this.dataSource.data = result;
      this.cdr.detectChanges();
    });
    this.search.valueChanges.pipe(debounceTime(this.DEBOUNCE_TIME), distinctUntilChanged()).subscribe((search: string) => {
      this.dataSource.filter = search.trim().toLowerCase();
    });
  }

  tableConfig: TableConfig<ImportFileXlsxStatus> = {
    onRowExpand: () => {},
    columns: {
      name: { cell: (elm: ImportFileXlsxStatus) => elm.userName.toString(), header: 'Name' },
      date: { cell: (elm: ImportFileXlsxStatus) => elm.startDate.toString().slice(0, 10), header: 'Date' },
      staus: { cell: 'status', header: 'Status', align: 'center' },
      file: { cell: 'file', header: '', align: 'center' }
    }
  };

  onNoClick(): void {
    this.dialogRef.close();
  }
  onClose() {
    this.dialogRef.close();
  }
  fileLink(statusId: number): string {
    return `${URL.url}downloadXlsxFile/${statusId}`;
  }
}
